import { useEffect, useState } from 'react';

/**
 * Below the desk breakpoint — the same 1024px `kit-extras.css` and MainLayout's
 * `lg` use.
 *
 * IT LIVES IN THE KIT because the kit itself asks the question: a DataTable
 * draws cards instead of columns down here. The shell reads it to decide
 * whether a page's phone layout shows, and a page reads it when its phone and
 * desk flows genuinely differ. `@/layouts/shellChrome` re-exports it, which is
 * where most callers still import it from.
 */
export function useNarrowViewport(): boolean {
  const query = '(max-width: 1023.98px)';
  const [narrow, setNarrow] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false,
  );
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(query);
    const on = () => setNarrow(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return narrow;
}
